import { Skeleton } from "@/components/ui/skeleton";

interface AppShellSkeletonProps {
  /** Accessible name for the loading region */
  ariaLabel?: string;
}

export function AppShellSkeleton({ ariaLabel = "Loading application" }: AppShellSkeletonProps) {
  return (
    <div
      className="flex min-h-screen flex-col bg-background"
      role="status"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      <header className="border-b border-gray-100 bg-white shadow-lg">
        <div className="mx-auto flex min-h-16 max-w-7xl items-center justify-between px-4 py-1.5 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2">
            <Skeleton className="h-10 w-10 shrink-0 rounded-lg" />
            <div className="hidden flex-col gap-1 sm:flex">
              <Skeleton className="h-5 w-52" />
              <Skeleton className="h-3 w-36" />
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="h-9 w-24 rounded-md" />
            <Skeleton className="h-9 w-9 rounded-full md:hidden" />
            <Skeleton className="hidden h-9 w-32 rounded-md md:block" />
          </div>
        </div>
      </header>
      <main className="mx-auto flex w-full max-w-7xl flex-1 flex-col gap-6 px-4 py-8 sm:px-6 lg:px-8">
        <Skeleton className="h-9 w-[min(100%,20rem)] rounded-md" />
        <div className="space-y-3">
          <Skeleton className="h-4 w-full max-w-3xl" />
          <Skeleton className="h-4 w-full max-w-2xl" />
          <Skeleton className="h-4 w-full max-w-xl" />
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <Skeleton className="h-36 rounded-xl" />
          <Skeleton className="h-36 rounded-xl" />
          <Skeleton className="h-36 rounded-xl" />
        </div>
      </main>
      <footer className="border-t border-gray-100 bg-white py-6">
        <div className="mx-auto flex max-w-7xl justify-center px-4 sm:px-6 lg:px-8">
          <Skeleton className="h-4 w-48" />
        </div>
      </footer>
    </div>
  );
}
